import {
  addGlobalContexts,
  BrowserTracker,
  clearUserData,
  newTracker,
  setUserId,
  StructuredEvent,
  trackSelfDescribingEvent,
  trackStructEvent,
} from '@snowplow/browser-tracker'
import Config from 'APP/Config'
import type { Entity } from 'App/Services/Analytics'

const COOKIE_SESSION_ID_INDEX = 6

export class _Snowplow {
  private tracker!: BrowserTracker

  init(): void {
    this.tracker = newTracker(Config.SNOWPLOW.NAMESPACE, Config.SNOWPLOW.ENDPOINT, {
      appId: Config.SNOWPLOW.APP_ID,
      // Every event stored in localstorage (when network calls fail, for example), takes a little more than 5000 bytes on average.
      // Localstorage's size limit is 5MB per origin. Snowplow shouldn't own the whole budget.
      // A reasonable Snowplow allocation is ~500KB, so about 100 calls.
      maxLocalStorageQueueSize: 100,
      contexts: {
        session: true,
      },
    })
  }

  setGlobalContexts = (entities: Entity[]): void => {
    addGlobalContexts(entities)
  }

  trackEvent = (
    schema: string,
    properties: Record<string, unknown>,
    trackedEntities?: Entity[]
  ): void => {
    trackSelfDescribingEvent({
      event: {
        schema: schema,
        data: properties,
      },
      context: trackedEntities,
    })
  }

  trackStructuredEvent = (event: StructuredEvent, entities?: Entity[]): void => {
    trackStructEvent({ ...event, context: entities })
  }

  setSubject = (id: string): void => {
    if (id === null) {
      clearUserData()
      return
    }
    setUserId('' + id)
  }

  trackScreen = (): void => {
    //No op on web, it uses `trackEvent` instead
  }

  getSessionId = async (): Promise<string | undefined> => {
    const domainUserInfo = this.tracker.getDomainUserInfo()
    // @ts-expect-error Snowplow's typing seems off because it definitely returns an object here
    return domainUserInfo ? domainUserInfo[COOKIE_SESSION_ID_INDEX] : null
  }
}

const Snowplow = new _Snowplow()

export default Snowplow
